export const LanguageRegions = {
  EUROPE: 'EUROPE',
  NORTH_AMERICA: 'NORTH_AMERICA',
  CHINA: 'CHINA',
  OTHER: 'OTHER',
  AUSTRALIA: 'AUSTRALIA',
}

export type LanguageRegions = (typeof LanguageRegions)[keyof typeof LanguageRegions]
